import React, { useState } from "react";
import { ChatWindowProps } from "./types";
import ChatHeader from "./ChatHeader";
import ChatFrame from "./ChatFrame";

const ChatWindow: React.FC<ChatWindowProps> = ({ isLoading, onClose, isMobile, onLoad }) => {
  const [frameLoading, setFrameLoading] = useState(isLoading);

  return (
    <>
      {/* Mobile: full-screen overlay */}
      {isMobile ? (
        <div className="sm:hidden fixed inset-0 z-[1100] flex flex-col bg-white">
          <ChatHeader onClose={onClose} />
          <ChatFrame isLoading={frameLoading} onLoad={() => setFrameLoading(false)} />
        </div>
      ) : (
        // Desktop: fixed-size card at bottom-right
        <div
          className="hidden sm:flex fixed bottom-4 right-4 z-[1100] flex-col bg-white border border-gray-300 shadow-lg overflow-hidden rounded-lg"
          style={{ width: "400px", height: "600px" }}
        >
          <ChatHeader onClose={onClose} />
          <ChatFrame isLoading={frameLoading} onLoad={() => setFrameLoading(false)} />
        </div>
      )}
    </>
  );
};

export default ChatWindow;
